<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import appConfig from "../../../../app.config";
import axios from 'axios';
// import moment from 'moment';
// import DataTable from 'datatables.net-vue3';
//import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import "@vueform/multiselect/themes/default.css";
import Swal from "sweetalert2";

export default {
    page: {
        title: "Instant Pay list",
        meta: [{ name: "description", content: appConfig.description }],
    },

    data() {
        return {
            role:localStorage.getItem('role'),
            title: "Generate Instant Pay",
            items: [
                {
                text: "Generate Instant Pay",
                href: "/",
                },
            ],

            payment_date: '',

            order_id:'',
            readonly_order_id:false,
            customer_name:'',
            customer_email:'',
            bank:'',
            amount:'',
            randomString:'',
            remark:'',

            listBank:[],
            submitLoading: false,
        };
    },
    

    methods: {

        getCurrentDate() {
            const today = new Date();
            const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
            this.payment_date = today.toLocaleDateString('en-US', options);
        },

        sanitizeInput() {
            this.amount = this.amount.replace(/[^\d.]/g, '');
            const dotIndex = this.amount.indexOf('.');
            if (dotIndex !== -1) {
                const remainingString = this.amount.slice(dotIndex + 1);
                const dotCount = (remainingString.match(/\./g) || []).length;
                if (dotCount > 0) {
                    this.amount = this.amount.slice(0, dotIndex + 1);
                }
            }
        },
        async getBank(){
            await axios.get(process.env.VUE_APP_API_NODEJS+'/bankList')
            .then(response => {
                console.log("BANK", response.data)
                if (response) {
                    this.listBank=response.data;
                                            
                } else {
                    this.messageBag = ['No record.'];
                    this.OrderSeen = false;
                }
            })
                .catch(error => {
                    this.messageBag = [error.error];
                    this.OrderSeen = false;
            });
        },

        generate(e){
            e.preventDefault();

            Swal.fire({
                title: "Are you sure you want to generate instant pay and send email to customer?",
                // text: "You won't be able to revert!",
                icon: "info",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, generate instant pay",
            }).then((result) => {
                if (result.value) {
                    this.submitLoading = true;
                    const posting_ = {
                        'amount': this.amount,
                        'email': this.customer_email,
                        'orderId': this.order_id,
                        'bank': this.bank,
                        'code': this.randomString,
                        'remark': this.remark,
                    };
                    axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
                    axios.post(process.env.VUE_APP_AR_API_BASEURL+'curlect/instant/create', posting_)
                    .then(response => {
                        if (response.data.status == 'success') {
                            Swal.fire({
                                title:"Instant pay generated!", 
                                html: "Email successfully sent.", 
                                icon:"success",
                            }).then(() => {
                                this.$router.push('/ar/instantpay/list');
                            });
                        } 
                        else {
                            Swal.fire({
                                title:"Instant Pay failed to generate!", 
                                // html: "Email successfully send.", 
                                icon:"warning",
                            })
                        }
                    })
                    .catch(error => {
                        this.messageBag = [error.error];
                        Swal.fire({
                            title:"Instant Pay failed to generate!", 
                            // html: "Email successfully send.", 
                            icon:"warning",
                        })
                    })
                    .finally(() => this.submitLoading = false);
                }
            });



            
        },

        searchorderId(){
            axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
            axios.get(process.env.VUE_APP_AR_API_BASEURL+'curlect/instant/order/'+this.order_id)
            .then(response => {
                if (response) {
                    this.loadingSearch=false;
                    this.showData=true;
                    this.customer_name = response.data.name_as_per_nric;
                    this.customer_email = response.data.email;
                    
                } 
                else {
                    this.messageBag = ['No record.'];
                }
            })
            .catch(error => {
                this.messageBag = [error.error];
            });
        },

        checkorder() {
            if (this.order_id.length > 11) {
                this.searchorderId();
            }
        },

        generateRandomString() {
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            let result = '';
            const charactersLength = characters.length;
            for (let i = 0; i < 40; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            this.randomString = result;
        },
        goBack() {
            this.$router.back();
        },
        
    },

    components: {
        Layout,
        PageHeader,
        //flatPickr,
        
    },

    mounted() {
        if (typeof this.$route.params.orderId !== 'undefined') {
            this.order_id=this.$route.params.orderId;
            this.readonly_order_id = true;
            this.checkorder();
        }

        this.getCurrentDate();
        this.getBank();
        this.generateRandomString();

        
    },
    
};
require("@/assets/css/datatable.css");
</script>
<style>
/* .col-xl-8 {
    flex: 0 0 auto;
    width: 82.66667% !important;
} */
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <!--button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#add_new_program_modal"  v-if="this.role = 1"><i class="ri-add-line align-middle me-1"></i> Add New Program</button> <br><br-->
        <!--div class="d-flex justify-content-end mb-3">
            <button @click="downloadExcel()" class="btn btn-success" v-if="this.role != 3"><i class="ri-file-excel-2-line align-middle me-1"></i> Export Excel</button><br><br>
        </div-->

        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header align-items-center d-flex">
                        <h4 class="card-title mb-0 flex-grow-1">Generate Instant Pay</h4>
                    </div>
                    <!-- end card header -->
                    <div class="card-body">
                        <form @submit="generate">
                            <div class="live-preview">
                                <div class="row gy-4">
                                    <div class="col-md-6">
                                        <div>
                                            <label for="basiInput" class="form-label">Order Id</label>
                                            <input type="text" class="form-control" v-model='order_id' @input="checkorder" required>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                    </div>
                                    <div class="col-md-6">
                                        <div>
                                            <label for="basiInput" class="form-label">Customer Name</label>
                                            <input type="text" class="form-control" v-model='customer_name' readonly required>
                                        </div>
                                    </div>
                                    <!--end col-->
                                    <div class="col-md-6">
                                        <div>
                                            <label for="labelInput" class="form-label">Email</label>
                                            <input type="text" class="form-control" v-model="customer_email" readonly required>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div>
                                            <label for="labelInput" class="form-label">Payment Date</label>
                                            <input type="text" class="form-control" v-model="payment_date" readonly>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div>
                                            <label for="labelInput" class="form-label">Amount (RM) <span style="color: red;">*</span></label>
                                            <input type="text" class="form-control" v-model="amount" @input="sanitizeInput" required>
                                        </div>
                                    </div>

                                    <div class="col-md-6">
                                        <div>
                                            <label for="labelInput" class="form-label">Bank <span style="color: red;">*</span></label>
                                            <select @change="onChange($event)" v-model="bank" class="form-select mb-3" arial-label="Default select example" required>
                                                <option value="">Please Select Bank</option>
                                                <option v-for="(item, index) in listBank" :key="index" :value="item.code['0']">
                                                    {{ item.name.toString().replace(/['"]+/g, '') }}
                                                </option>
                                        
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-xxl-3 col-md-6">
                                    </div>
                                    <div class="col-xxl-12 col-md-12">
                                        <div>
                                            <label for="exampleFormControlTextarea5" class="form-label">Remark</label>
                                            <textarea class="form-control" id="exampleFormControlTextarea5" v-model="remark" rows="3" required maxlength="27" placeholder="Maximum 27 charater"></textarea>
                                        </div>
                                    </div>
                                    <div class="col-md-6"></div>   
                                </div>
                            </div>
                            <div class="row g-3 justify-content-end">
                                <div class="col-sm-2">
                                    <div>
                                        <div @click="goBack">
                                            <button class="btn btn-success w-100">Cancel</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-2">
                                    <div>
                                        <div v-if="submitLoading" class="spinner-border text-success">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                        <button v-if="!submitLoading" type="submit" class="btn btn-danger w-100">
                                            Generate & Send Email
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            <!--end col-->
            </div>
        </div>






            
    </Layout>
</template>